export default "__VITE_ASSET__COBez_Fc__"